import { WifiOff } from "lucide-react";
import { useConnectivity } from "@/pwa/useConnectivity";

export const OfflineBanner = () => {
  const online = useConnectivity();
  if (online) return null;
  return (
    <div data-testid="offline-banner"
      className="sticky top-0 z-30 border-b border-[#F5C6A5] bg-[#FFF3E9] text-[#8A4B1E] px-4 py-2 text-xs sm:text-sm flex items-center gap-2">
      <WifiOff className="h-4 w-4 shrink-0" />
      <span><b>Connessione assente.</b> I dati visualizzati potrebbero non essere aggiornati.</span>
    </div>
  );
};

// Shared cold-start "no data available offline" placeholder.
export const DataUnavailable = ({ testid = "data-unavailable" }) => (
  <div data-testid={testid} className="rounded-2xl border border-dashed border-border bg-card p-6 text-center">
    <WifiOff className="h-6 w-6 mx-auto text-muted-foreground mb-2" />
    <p className="text-sm text-muted-foreground">Dati non disponibili senza connessione.</p>
  </div>
);
